import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { DataService } from '../shared/dataService';

@Injectable({
    providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {

    private auth: DataService;

    constructor(private injector: Injector, private router: Router) { }

    jwtHelper: JwtHelperService = new JwtHelperService();

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        this.auth = this.injector.get(DataService);

        const accToken = this.auth.getAccessToken();
        const refToken = this.auth.getRefreshToken();
        console.log(refToken);
        if (accToken && accToken.length > 0 && refToken && refToken.length >0) {

            if (this.jwtHelper.isTokenExpired(accToken)) {
                this.auth.refreshTokens().pipe(
                    tap(
                        () => {
                            req = req.clone({
                                setHeaders: {
                                    Authorization: `Bearer ${accToken}`
                                }
                            });
                        }
                    )
                )
            } else {
                req = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${accToken}`
                    }
                });
            }

        }
        return next.handle(req).pipe(
            catchError(
                (error: HttpErrorResponse) => this.handleAuthError(error)
            )
        );
    }

    private handleAuthError(error: HttpErrorResponse): Observable<any> {
        if (error.status === 401) {
            this.router.navigate(['/login'], {
                queryParams: {
                    sessionFailed: true
                }
            });
        }
        return throwError(error);
    }

}